import {stationDetailRoutes} from './stationDetail/routes';
import ToMyWeather from './ToMyWeather';

export const stationRoutes = [
  {
    path: '',
    element: <ToMyWeather />,
  },
  {
    path: 'search',
    lazy: async () => import('../../../screens/stations/StationSearch'),
  },
  {
    path: 'manage',
    lazy: async () => import('../../../screens/stations/StationManage'),
  },
  {
    path: ':id',
    lazy: async () => import('./stationDetail'),
    children: stationDetailRoutes,
  },
  {
    path: '*',
    lazy: async () => import('../../../screens/NotFound'),
  },
];
